import { render, staticRenderFns } from "./ContentOrderDetail.vue?vue&type=template&id=6e2d73bb"
import script from "./ContentOrderDetail.vue?vue&type=script&lang=js"
export * from "./ContentOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports